import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';

const pad = (n) => String(n).padStart(2, '0');
const key = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

const MultiDatePicker = ({ value = [], onChange, language, minDate }) => {
  const pt = language === 'pt';
  const [cursor, setCursor] = useState(() => { const n = new Date(); return new Date(n.getFullYear(), n.getMonth(), 1); });
  const todayKey = key(new Date());
  const min = minDate || todayKey;
  const y = cursor.getFullYear(), m = cursor.getMonth();
  const offset = (new Date(y, m, 1).getDay() + 6) % 7;
  const total = new Date(y, m + 1, 0).getDate();
  const cells = [...Array(offset).fill(null), ...Array.from({ length: total }, (_, i) => new Date(y, m, i + 1))];
  const toggle = (k) => onChange(value.includes(k) ? value.filter(x => x !== k) : [...value, k].sort());

  return (
    <div className="border border-rose-200 rounded-xl bg-white p-3" data-testid="multi-date-picker">
      <div className="flex items-center justify-between mb-2">
        <button type="button" onClick={() => setCursor(new Date(y, m - 1, 1))} className="p-1 rounded hover:bg-gray-100" data-testid="mdp-prev"><ChevronLeft size={16} /></button>
        <span className="text-sm font-semibold capitalize" data-testid="mdp-label">{cursor.toLocaleDateString(pt ? 'pt-PT' : 'en-IE', { month: 'long', year: 'numeric' })}</span>
        <button type="button" onClick={() => setCursor(new Date(y, m + 1, 1))} className="p-1 rounded hover:bg-gray-100" data-testid="mdp-next"><ChevronRight size={16} /></button>
      </div>
      <div className="grid grid-cols-7 gap-1 text-center text-[11px] text-gray-500 mb-1">
        {(pt ? ['S', 'T', 'Q', 'Q', 'S', 'S', 'D'] : ['M', 'T', 'W', 'T', 'F', 'S', 'S']).map((d, i) => <div key={i}>{d}</div>)}
      </div>
      <div className="grid grid-cols-7 gap-1">
        {cells.map((d, i) => {
          if (!d) return <div key={`e${i}`} />;
          const k = key(d);
          const disabled = k < min;
          const on = value.includes(k);
          return (
            <button key={k} type="button" disabled={disabled} onClick={() => toggle(k)} data-testid={`mdp-day-${k}`}
              className={`h-8 rounded-lg text-sm transition-colors ${on ? 'bg-rose-500 text-white font-semibold' : disabled ? 'text-gray-300' : 'hover:bg-rose-100 text-gray-700'} ${k === todayKey && !on ? 'ring-1 ring-rose-400' : ''}`}>
              {d.getDate()}
            </button>
          );
        })}
      </div>
      {value.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-1" data-testid="mdp-selected">
          {value.map(k => (
            <span key={k} className="inline-flex items-center gap-1 text-xs bg-rose-50 text-rose-700 border border-rose-200 rounded-full px-2 py-0.5">
              {new Date(k + 'T00:00:00').toLocaleDateString(pt ? 'pt-PT' : 'en-IE', { weekday: 'short', day: '2-digit', month: '2-digit' })}
              <button type="button" onClick={() => toggle(k)} className="hover:text-rose-900"><X size={10} /></button>
            </span>
          ))}
          <button type="button" onClick={() => onChange([])} className="text-xs text-gray-500 hover:underline ml-1">{pt ? 'limpar' : 'clear'}</button>
        </div>
      )}
    </div>
  );
};

export default MultiDatePicker;
